import React from "react";
import { Empty, Skeleton } from "antd";
import ExamBankChildCard from "./ExamBankChildCard";
import { sortByOrder } from "../../../utils/examBankOrder";

const getBankId = (record) => record?.Id ?? record?.id;

const ExamBankChildren = ({
    children,
    onEdit,
    onDelete,
    onAddChild,
    onManageExams,
    onExpand,
    level = 1,
    isLoading = false,
    loadedChildren,
    loadingChildren,
    expandedNodes = {},
}) => {
    if (isLoading) {
        return (
            <div className="p-4">
                <Skeleton active paragraph={{ rows: 2 }} />
            </div>
        );
    }

    if (!children || children.length === 0) {
        return (
            <div className="p-4 text-center">
                <Empty description="هیچ فرزندی وجود ندارد" />
            </div>
        );
    }

    const sortedChildren = sortByOrder(children);

    return (
        <div className="pr-2">
            {sortedChildren.map((child) => {
                const childId = getBankId(child);
                const isChildExpanded = expandedNodes[childId];

                return (
                    <div key={childId}>
                        <ExamBankChildCard
                            child={child}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            onAddChild={onAddChild}
                            onManageExams={onManageExams}
                            onExpand={onExpand}
                            level={level}
                            isLoading={loadingChildren[childId]}
                            isExpanded={isChildExpanded}
                        />
                        {isChildExpanded && (
                            loadingChildren[childId] ? (
                                <div className="p-4">
                                    <Skeleton active paragraph={{ rows: 2 }} />
                                </div>
                            ) : (
                                <ExamBankChildren
                                    children={loadedChildren[childId] || []}
                                    onEdit={onEdit}
                                    onDelete={onDelete}
                                    onAddChild={onAddChild}
                                    onManageExams={onManageExams}
                                    onExpand={onExpand}
                                    level={level + 1}
                                    loadedChildren={loadedChildren}
                                    loadingChildren={loadingChildren}
                                    expandedNodes={expandedNodes}
                                />
                            )
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ExamBankChildren;
